<template>
  <div class="pop-over">
    <div>
        <h4>{{ $t("send_results.loading") }}</h4>
        <div class="loader"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingPopup',

  data() {
    return {
      showLoading: true,
    };
  },
};
</script>

<style scoped>
.pop-over {
  background-color: #f0f0f2;
  position: fixed;
  margin: auto;
  width: 500px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  border-radius: 15px;

}


.footer {
  display: grid;
  grid-gap: 10px;
  padding: 60px 10px 10px 0;
  grid-template-columns: 50% 50%;
}

.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}

.btn {
  width: 160px;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>